module.exports = __webpack_public_path__ + "static/img/Lykhan-King-Togia.f3f2358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lykhan-King-Togia.jpg
// module id = 9Fog
// module chunks = 0